var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }